import React from 'react';
import { Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useSessionVerification } from 'hooks/useSessionVerification';
import { applySessionRecruiterLanguage } from 'recruiter-i18n';
import { SHELL_NS } from 'recruiter-i18n/namespaces/shell';
import { sessionEffectiveLanguage } from 'stores/sessionStore';
import { useSupportUserStore } from 'stores/supportUserStore';

import { RecruiterLanguageSelect } from './RecruiterLanguageSelect';

/** Changes support's display only; the mocked member remains the language authority for AI. */
export function SupportLanguagePicker() {
  const { t } = useTranslation(SHELL_NS);
  const { member } = useSessionVerification();
  const isSupportUser = useSupportUserStore((state) => state.isSupportUser);
  const language = useSupportUserStore((state) => state.uiLanguageOverride);
  const setLanguage = useSupportUserStore(
    (state) => state.setUiLanguageOverride
  );
  if (!isSupportUser) return null;

  return (
    <Stack gap='xs' p='xs' maw={300}>
      <RecruiterLanguageSelect
        label={t('account.supportLanguage')}
        nullOptionLabel={t('account.supportLanguageDefault')}
        value={language}
        withinPortal={false}
        onChange={(next) => {
          setLanguage(next);
          void applySessionRecruiterLanguage(
            member ? sessionEffectiveLanguage(member) : null
          );
        }}
      />
      <Text size='xs' c='dimmed'>
        {t('account.supportLanguageDescription')}
      </Text>
    </Stack>
  );
}
